module.exports = __webpack_public_path__ + "img/bigpreloader.150104cf.png";